<template>
	<div :class="classes"/>
</template>

<script>
export default {
	name: 'Divider',
	props: {
		hasError: Boolean,
		hasFocus: Boolean
	},
	computed: {
		classes() {
			return `btn-divider ${this.hasFocus && 'btn-divider--has-focus'} ${this.hasError && 'btn-divider--has-error'}`;
		}
	}
}
</script>

<style lang="scss" scoped>
.btn-divider {
	border-left: solid 1px rgba(0, 0, 0, 0.12);
	height: 1.25rem;
	position: relative;
	top: 0.25rem;

	&--has-focus {
		border-left: solid 1px #cfe39c;
	}

	&--has-error {
		border-left: solid 1px #efc1c1;
	}
}
</style>